document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".ranking__tab li").forEach((tab) =>
    tab.addEventListener("click", () => {
      const target = tab.dataset.tab;

      document.querySelectorAll(".ranking__tab li").forEach((t) =>
        t.classList.remove("active")
      );
      tab.classList.add("active");

      document.querySelectorAll(".tab-content").forEach((content) => {
        content.classList.toggle("active", content.classList.contains(target));
      });
    })
  );
});